import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse";
import { ListQuestionairesQueryParamsDTO } from "@/domain/dto/ListQuestionairesQueryParamsDTO";
import { Questionaire } from "@/domain/entities/Questionaire";
import { IQuestionaireRepository } from "@/domain/repositories/IQuestionaireRepository";
import { IListQuestionairesUseCase } from "@/domain/usecases/IListQuestionairesUseCase";

export class ListQuestionairesUseCase implements IListQuestionairesUseCase {
    repository: IQuestionaireRepository
    constructor(repository: IQuestionaireRepository) {
        this.repository = repository
    }

    execute(params: ListQuestionairesQueryParamsDTO): Promise<PaginatedListResponse<Questionaire>> {
        return this.repository.list(params)
    }
}
